import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 5px;
  border: 1px dashed #cfd8dc;
  color: #90a4ae;
  text-align: center;
  padding: 32px;
  box-sizing: border-box;
`

const MapIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#b0bec5"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginBottom: 16 }}
  >
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
    <line x1="9" y1="3" x2="9" y2="18" />
    <line x1="15" y1="6" x2="15" y2="21" />
  </svg>
)

const Title = styled.p`
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  color: #546e7a;
`

const Subtitle = styled.p`
  margin: 0 0 20px;
  font-size: 13px;
  color: #90a4ae;
  max-width: 260px;
  line-height: 1.5;
`

const ReloadButton = styled.button`
  padding: 8px 22px;
  background: #5cbbdb;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: background 0.15s;

  &:hover {
    background: #4aa8c8;
  }
`

class MapErrorBoundary extends React.Component {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  render() {
    if (this.state.failed) {
      return (
        <Wrapper>
          <MapIcon />
          <Title>Map unavailable</Title>
          <Subtitle>
            WebGL could not be initialised in this browser.
            Try reloading the page or enabling hardware acceleration in your browser settings.
          </Subtitle>
          <ReloadButton onClick={() => window.location.reload()}>
            Reload page
          </ReloadButton>
        </Wrapper>
      )
    }

    return this.props.children
  }
}

export { MapErrorBoundary }
